import {Message, MessageBox} from "element-ui";
import {getYearMonthDayBySeverTime} from "@/utils/time";
import {getFileUrl} from "@/api/file";

export function getMultipleValue(resultArray, originArray) {
    if (!resultArray.length) {
        return '';
    }
    let tempNum = 0, tempStr = '';
    resultArray.forEach(item => tempNum += item);
    console.log(tempNum);
    tempStr = tempNum.toString();
    tempStr = ('000000' + tempStr).slice(-originArray.length);
    console.log('tempStr', tempStr);
    return tempStr;
}

export function dealDeleteOperation({deletePromise}) {
    return new Promise((resolve, reject) => {
        MessageBox.confirm('即将执行删除操作, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            return deletePromise;
        }).then(() => {
            resolve();
            Message.success('删除成功!');
        });
    })

}

export function formatDateFromSever(severData) {
    // console.log('aaa',severData);
    const {sDate,eDate,sample} = severData;//timeSeg, validateS, validateE, 
    
    return {
        ...severData,
        dateArray: [getYearMonthDayBySeverTime(sDate), getYearMonthDayBySeverTime(eDate)],
        // sample: getSampleArrayFromSever({sample}),
    };
}

export function formatDateFromSeverDouble(severData) {
    // console.log('aaa',severData);
    const {sDate,eDate,useSDate,useEDate} = severData;//timeSeg, validateS, validateE, 
    
    return {
        ...severData,
        dateArray: [getYearMonthDayBySeverTime(sDate), getYearMonthDayBySeverTime(eDate)],
        dateArray2: [getYearMonthDayBySeverTime(useSDate), getYearMonthDayBySeverTime(useEDate)],
        // sample: getSampleArrayFromSever({sample}),
    };
}


export function formatDate(params ) {
    let defalutParams = {
      date: new Date(),
      formatStr: 'yyyy-MM-dd HH:mm:ss'
    }
    params = { ...defalutParams, ...params };
    let date = params.date;
    let formatStr = params.formatStr;
    // 传入日期字符串 - 转成时间戳 - 转成标准时间
    let timeStamp = new Date(date).getTime();
    date = new Date(timeStamp);
    formatStr = formatStr.replace(new RegExp('yyyy'), `${date.getFullYear()}`);
    const month = date.getMonth() + 1;
    formatStr = formatStr.replace(new RegExp('MM'), `${month > 9 ? month : '0' + month}`);
    const day = date.getDate();
    formatStr = formatStr.replace(new RegExp('dd'), `${day > 9 ? day : '0' + day}`);
    const hour = date.getHours();
    formatStr = formatStr.replace(new RegExp('HH'), `${hour > 9 ? hour : '0' + hour}`);
    const min = date.getMinutes();
    formatStr = formatStr.replace(new RegExp('mm'), `${min > 9 ? min : '0' + min}`);
    const sec = date.getSeconds();
    formatStr = formatStr.replace(new RegExp('ss'), `${sec > 9 ? sec : '0' + sec}`);
    return formatStr;
  }

  export function getSampleArrayFromSever({samples}) {
    // console.log('samples',samples)
    return samples?.split(';').filter(item => !!item).map(fileName => {
        return {name: fileName, url: getFileUrl({name: fileName,subDir:''})};
    }) ?? []
}


export function getSampleLogStrToSever({sampleArr}) {
    return sampleArr?.map(item => item.name).join(';') ?? '';
}


export function _isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag;
}